<template>
  <div>
    <div
      class="guoNeng-reminder"
      v-if="showReminder"
      :style="{ top: headerHeight + 'px' }"
      :class="{ 'is-screen-share': isScreenShare }"
    >
      <img
        class="warn-icon"
        src="@saas/pages/assets/images/live/warning.png"
        alt=""
      />
      <span class="text">预警：10 分钟内需充值果能点，以免中断</span>
      <button class="btn" @click="jumpRechargeUrl">立即充值</button>
    </div>
    <!-- 将 endClassRef 移出 v-if，确保组件始终存在 -->
    <end-class ref="endClassRef" :reason="reason"></end-class>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import EndClass from "./components/EndClass.vue";
import { MessageBox } from "element-ui";
import { playMediaSafely } from "@saas/components/src/utils/media-play";
export default {
  components: {
    EndClass,
  },
  data: function () {
    return {
      showReminder: false,
      rechargeUrl: `${process.env.VUE_APP_SAAS_WEB_URL}/biz/teaching/coin-detail?recharge=1&type=1`,
      appRechargeUrl: `${process.env.VUE_APP_SAAS_WEB_URL}/biz/fruit-recharge?type=1`,
      headerHeight: 0,
      isLoading: false,
      showConfirm: false,
      showEndClass: false,
      reason: "",
    };
  },
  mounted() {},
  watch: {
    liveAndImIsReady: {
      handler(val) {
        if (val) {
          this.handleIMListen();
        }
      },
      immediate: true,
    },
  },

  methods: {
    // im的监听事件
    handleIMListen() {
      if (this.imService) {
        this.imService.on("recvMGLiveRoomCustomMsg", (res) => {
          console.log("recvMGLiveRoomCustomMsg___", res);
          const { data } = res;
          if (data.type === "ServerMsg") {
            this.handleCustomServerMsg(data.data);
          }
        });
      } else {
        console.error("imService__未准备好");
      }
    },
    liveRoomHeaderHeightDynamic() {
      const headerElement = document.querySelector(".comp-container__header");
      if (headerElement) {
        const height = window.getComputedStyle(headerElement).height;
        return parseInt(height, 10); // 返回数字，单位 px
      }
      // 如果元素不存在，返回默认值
      return 0;
    },
    handleCustomServerMsg(data = {}) {
      console.log("handleCustomServerMsg___", data);
      const { msg_body, msg_type } = data || {};
      switch (msg_type) {
        case "PointDeficiency":
          // 已经在展示了头部预警提醒||已经弹出了Confirm-不再弹出Confirm
          if (this.showReminder || this.showConfirm) {
            return false;
          }
          this.showConfirm = true;
          this.headerHeight = this.liveRoomHeaderHeightDynamic();
          // 果能点不足
          this.$confirm(
            "<span style='color: #F03349'>果能点不足10分钟内需充值果能点，以免中断服务。</span>",
            "提示",
            {
              center: true,
              cancelButtonText: "暂不充值",
              confirmButtonText: "立即充值",
              customClass: "saas-confirm-message",
              confirmButtonClass: "confirm-btn",
              cancelButtonClass: "cancel-btn",
              closeOnClickModal: false,
              dangerouslyUseHTMLString: true,
            }
          )
            .then(() => {
              this.showConfirm = false;
              this.jumpRechargeUrl();
              this.showReminder = true;
            })
            .catch(() => {
              this.showConfirm = false;
              this.showReminder = true;
            });
          break;
        case "PointBuy":
          this.showConfirm = false;
          // 果能点充值成功
          this.showReminder = false;
          // 关闭 confirm 弹窗
          MessageBox.close();
          break;
        case "RoomEnd":
          console.log("====RoomEnd");
          let { reason } = JSON.parse(msg_body) || {};
          this.reason = reason || "";
          // 使用 $nextTick 确保 DOM 更新后再调用
          this.$nextTick(() => {
            this.$refs.endClassRef?.open();
          });
          if (window.isElectron) {
            window.ipcRenderer.send("end-class", {
              lessonId: this.lessonId,
              courseId: this.roomInfo.course_id,
            });
          } else {
            void playMediaSafely(this.$endClassBell);
          }
          break;
      }
    },
    jumpRechargeUrl() {
      // 跳转
      if (window.isElectron) {
        window.openUrlByExternal(this.rechargeUrl);
      } else {
        window.open(this.rechargeUrl);
      }
    },
  },
  computed: {
    ...mapState("live", [
      "imService",
      "screenShareStatus",
      "lessonId",
      "roomInfo",
    ]),
    ...mapGetters("live", ["liveAndImIsReady"]),
    // 是否在共享(共享端)
    isScreenShare() {
      return ["start", "pause"].includes(this.screenShareStatus);
    },
  },
};
</script>

<style lang="scss" scoped>
.guoNeng-reminder {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1600;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background: linear-gradient(93deg, #ffecf1 0%, #ffecf0 100%);
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  color: #1d2129;
  line-height: 20px;
  .warn-icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .text {
    margin-right: 40px;
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 28px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    background: linear-gradient(
      115deg,
      #ff7a00 0%,
      #ff5037 35%,
      #ff3135 68%,
      #ff27c0 100%
    );
    --icon-color: transparent;
    --icon-second-color: transparent;
    --icon-third-color: transparent;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}
.is-screen-share {
  z-index: 999;
}
</style>
